import { csx } from '@vtex/admin-ui'
import React from 'react'

import ClosePaymentAppIcon from './ClosePaymentAppIcon'

interface PaymentAppHeaderProps {
  onDismiss: () => void
}

export const PaymentAppHeader = ({
  onDismiss: handleDismiss,
}: PaymentAppHeaderProps) => {
  return (
    <div
      className={csx({
        height: '56px',
        padding: '16px',
        borderBottom: '1px solid',
        borderColor: '#DDDDDD',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'end',
      })}
    >
      <ClosePaymentAppIcon onClose={handleDismiss} />
    </div>
  )
}

export default PaymentAppHeader
